import React, { useState } from "react";
import styled from "styled-components";

import { Container, ThumbnailImage } from "./ImageReview.styles";
import { ImageReviewContainer } from "./ImageReviewContainer";

export const ImageReview = ({ src, alt }) => {
    const [ isZoomed, setIsZoomed ] = useState(false);
    const altText = `${ alt } thumbnail`;

    const handleImageClick = () => {
        if(!isZoomed) setIsZoomed(true);
    };

    const closeModal = () => {
        setIsZoomed(false);
    };

    return (
        <Container onClick={ handleImageClick }>
            <ThumbnailImage src={ src } alt={ altText }/>
            { isZoomed &&
                <ImageReviewContainer
                    src={ src }
                    alt={ altText }
                    onClose={ closeModal }
                />
            }
        </Container>
    );
};
